/**
 * MyLojicLogo — Inline SVG logo component
 *
 * v1.0 - v4.07: Inline SVG replaces <img> tags to fix flex-container sizing issues - 2026-03-20
 *
 * Usage:
 *   <MyLojicLogo isDark height={36} />
 *
 * isDark=true  → white "MyLojic" text (for dark backgrounds)
 * isDark=false → dark  "MyLojic" text (for light backgrounds)
 * height controls size; width is auto-calculated from 560:120 aspect ratio
 */
import React from 'react';

interface MyLojicLogoProps {
  isDark?: boolean;
  height?: number;
}

const MyLojicLogo: React.FC<MyLojicLogoProps> = ({ isDark = true, height = 36 }) => {
  // SVG viewBox is 560×120 — maintain aspect ratio
  const width = Math.round((height * 560) / 120);
  const textColor = isDark ? '#FFFFFF' : '#1B2A4A';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 560 120"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="mlRingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#00C9A7" />
          <stop offset="35%"  stopColor="#F4A261" />
          <stop offset="65%"  stopColor="#E87461" />
          <stop offset="100%" stopColor="#00C9A7" />
        </linearGradient>
        <linearGradient id="mlMGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#00C9A7" />
          <stop offset="50%"  stopColor="#50B848" />
          <stop offset="100%" stopColor="#F4A261" />
        </linearGradient>
      </defs>
      <circle cx="60" cy="60" r="38" fill="none" stroke="url(#mlRingGrad)" strokeWidth="9" />
      <text
        x="60" y="73"
        textAnchor="middle"
        fontSize="36"
        fontFamily="Arial, sans-serif"
        fontWeight="700"
        fill="url(#mlMGrad)"
      >
        M
      </text>
      <text
        x="116" y="74"
        fontSize="40"
        fontFamily="Arial, sans-serif"
        fontWeight="600"
        fill={textColor}
      >
        MyLojic
      </text>
    </svg>
  );
};

export default MyLojicLogo;
